// src/Public/faq-data.js

const FaqData = {
    en: {
        title: 'Frequently Asked Questions',
        subtitle: 'Everything you need to know about our marine construction services.',
        items: [
            {
                id: 'faq-1',
                question: 'What areas do you serve?',
                answer: 'We serve Cape Coral, Fort Myers, Lee County, and Collier County in Southwest Florida (SWFL). We are the preferred marine contractor in the region.'
            },
            {
                id: 'faq-2',
                question: 'Are you licensed and insured?',
                answer: 'Yes. Tropical Marine Construction holds a Florida Certified Building Contractor license (State License #CBC1260600) and is fully insured. We meet all city, county, state, and federal laws and permit regulations. No construction begins until we have secured all necessary permits.'
            },
            {
                id: 'faq-3',
                question: 'What types of docks do you build?',
                answer: 'We build stationary boat docks, floating docks, kayak docks, jet ski docks, slip docks, canoe docks, paddleboard docks, and wrap-around docks using wood, composite (Tandeck®), and other premium materials rated for the SWFL marine environment.'
            },
            {
                id: 'faq-4',
                question: 'Do you handle permits?',
                answer: 'Yes. We manage every step — from initial consultation and custom design through permit procurement, construction, and final inspection. Construction does not begin until all necessary permits are in place.'
            },
            {
                id: 'faq-5',
                question: 'What size boat lifts do you install?',
                answer: 'We install boat lifts from small PWC and jet ski lifts all the way up to 20,000 lb capacity systems. We carry new FMS Boat Lift U.S. models as well as quality used boat lifts at competitive prices.'
            },
            {
                id: 'faq-6',
                question: 'How often should I service my boat lift?',
                answer: 'In SWFL, the salt water, tropical rains, blistering sun, and heat require regular preventative maintenance. We recommend a full inspection at least once a year. Our Boat Lift Maintenance Program keeps your lift safe and running year round.'
            },
            {
                id: 'faq-7',
                question: 'How long does a tiki hut last in Florida?',
                answer: 'Our commercial-grade tiki hut structures are built with durable bamboo facings, trims, and premium thatch that is 99% waterproof, mold and mildew resistant, and built to withstand hurricane-level winds. Permanent tiki umbrella structures last twice as long as cloth or canvas alternatives.'
            },
            {
                id: 'faq-8',
                question: 'How do I get an estimate?',
                answer: 'Call us at (239) 542-1004 or fill out our contact form. We will respond promptly and schedule a consultation to assess your project and provide a written quote at no charge.'
            }
        ]
    },

    he: {
        title: 'Frequently Asked Questions',
        subtitle: 'Everything you need to know about our marine construction services.',
        items: [
            {
                id: 'faq-1',
                question: 'What areas do you serve?',
                answer: 'We serve Cape Coral, Fort Myers, Lee County, and Collier County in Southwest Florida (SWFL). We are the preferred marine contractor in the region.'
            },
            {
                id: 'faq-2',
                question: 'Are you licensed and insured?',
                answer: 'Yes. Tropical Marine Construction holds a Florida Certified Building Contractor license (State License #CBC1260600) and is fully insured. We meet all city, county, state, and federal laws and permit regulations.'
            },
            {
                id: 'faq-3',
                question: 'What types of docks do you build?',
                answer: 'We build stationary boat docks, floating docks, kayak docks, jet ski docks, slip docks, canoe docks, paddleboard docks, and wrap-around docks using wood, composite (Tandeck®), and other premium materials.'
            },
            {
                id: 'faq-4',
                question: 'Do you handle permits?',
                answer: 'Yes. We manage every step — from initial consultation and custom design through permit procurement, construction, and final inspection.'
            },
            {
                id: 'faq-5',
                question: 'What size boat lifts do you install?',
                answer: 'We install boat lifts from small PWC and jet ski lifts all the way up to 20,000 lb capacity systems.'
            },
            {
                id: 'faq-6',
                question: 'How often should I service my boat lift?',
                answer: 'In SWFL, we recommend a full inspection at least once a year. Salt, heat, and tropical storms accelerate wear significantly.'
            },
            {
                id: 'faq-7',
                question: 'How long does a tiki hut last in Florida?',
                answer: 'Our commercial-grade structures use 99% waterproof thatch that withstands hurricane-level winds. Permanent structures last twice as long as canvas alternatives.'
            },
            {
                id: 'faq-8',
                question: 'How do I get an estimate?',
                answer: 'Call us at (239) 542-1004 or fill out our contact form. We respond promptly and provide written quotes at no charge.'
            }
        ]
    }
};

export function getFaqData(language) {
    return FaqData[language === 'he' ? 'he' : 'en'];
}

export default FaqData;
